import { StepType } from 'src/app/shared/shared.module';
import {
    getInputField, setAsRequired, setRegexValidation,
    getSelectField, getDateField, setDisableWhen, setRequiredWhen, getTelephoneField, setAsRequiredEmail,
} from 'src/app/shared/form';
import { VisaType } from '../../visatypes';
import { isNullOrUndefined } from '../../../../../../app/core/utils';

import { FieldTooltip } from '../../field-tooltip.enum';

import { setAsDisabled, setAsHiddenWhen, setAsReadOnlyRequiredWhen, setYesNoValues } from '../../../../../shared/form/form-utils';
import { map } from 'rxjs/operators';


export class EmploymentVisa extends VisaType {

    GetRequesterSteps(operations?: () => string[]): StepType[] {

        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.EmpProfileSearch(null, operations),

                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.nonMandatoryGpn(),
                            this.nonMandatoryGui(),
                            //this.gpnGuiSearchButton(operations)
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.firstName(),
                            this.middleName(),
                            this.lastName()
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            // getTelephoneField("Mobile number", setDisablePhoneFieldWhen((model) => model.isAutoGenerated == 1 && !isNullOrUndefined( model.phoneNumber),setAsRequired())),
                            // getInputField("emailAddress", "Email ID", setDisablewithValueWhen((model) => model.isAutoGenerated == 1 && !isNullOrUndefined( model.emailAddress),
                            // setAsRequiredEmail())),
                            getTelephoneField("Mobile number", setAsRequired(this.addFieldTooltipWithAdditionalConfig('Mobile number'))),
                            getInputField("emailAddress", "Email ID", setAsRequiredEmail(this.addFieldTooltipWithAdditionalConfig('Email ID'))),
                            this.nationalityTypeWithSpecialExpact(),
                            this.nationality(),
                            getSelectField(
                                "dualCitizenship.id",
                                "Dual citizenship",
                                this.common.getSelectFieldOptions(this.yesNo$, '',
                                    setAsRequired(this.addFieldTooltipWithAdditionalConfig('Dual citizenship')))
                            ),
                            getSelectField(
                                "secondNationality.id", "Second nationality",
                                this.common.getSelectFieldOptionsExcept(this.nationality$, 'nationality.id',
                                    this.addFieldTooltipWithAdditionalConfig('second nationality',setDisableWhen((model) =>
                                        !isNullOrUndefined(model.dualCitizenship) && model.dualCitizenship.id !== 1074,
                                        setRequiredWhen((model) =>
                                            !isNullOrUndefined(model.dualCitizenship) && model.dualCitizenship.id === 1074)                                       
                                    ))
                            )),
                            // this.onboardingType(
                            //     this.common.getPbTypeWrtNationality()
                            // ),
                            this.gender(),
                            getSelectField(
                                "serviceLine.id",
                                "Service line",
                                this.common.getSelectFieldOptions(this.serviceLines$, '',
                                    setAsRequired())
                            ),
                            getSelectField(
                                "subServiceLine.id",
                                "Sub-service line",
                                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                                    setAsRequired())
                            ),
                            this.rank(),
                            this.officeLocation(),
                            this.officeLE('EY legal entity'),

                        ]
                    }
                ]
            },
            {
                label: "Step 2",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [

                        ]
                    }, {

                        fieldGroupClassName: "row",
                        fieldGroup: [
                            // this.grade(),

                            getSelectField(
                                "employeeCurrentLocationCountry.id",
                                "Current location - country",
                                this.common.getSelectFieldOptions(this.nationality$, '',
                                    this.addFieldTooltipWithAdditionalConfig('Current location - country')
                                )
                            ),
                            getInputField(
                                "currentCity",
                                "Current location- city",
                                setRegexValidation(/^[a-zA-Z -]*$/,
                                    'Please enter a valid name', null)
                            ),
                            getInputField(
                                "academicQualification",
                                "Academic qualification",
                                setAsRequired(this.addFieldTooltipWithAdditionalConfig('Academic qualification'))
                            ),
                            getInputField(
                                "visaAgentName",
                                "Visa agent name",
                                setRegexValidation(/^[a-zA-Z -]*$/,
                                    'Please enter a valid name')
                            ),
                            getInputField(
                                "visaNumber",
                                "Visa number",
                                setAsRequired()
                            ),
                            getInputField(
                                "visaDesignation",
                                "Visa designation",
                                setAsRequired()
                            ),
                            getSelectField(
                                "specialExpat",
                                "Special expat",
                                setYesNoValues(this.common.getSpecialExpactWrtNationalityType(setAsRequired(this.addFieldTooltipWithAdditionalConfig('special expat'))))
                            ),
                            // getInputField(
                            //     "saSerialNumber",
                            //     "IBAN Number",
                            //     setAsRequired()
                            // )
                            getSelectField(
                                "currentGccResident.id",
                                "Is new joiner a current GCC resident?",
                                this.common.getSelectFieldOptions(this.yesNo$, '', setAsRequired())
                            ),
                        ]
                    },
                ]
            },
            {
                label: "Step 3",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [

                            // getSelectField(
                            //     "currentGccResident.id",
                            //     "Is new joiner a current GCC resident?",
                            //     this.common.getSelectFieldOptions(this.yesNo$, '', setAsRequired())
                            // ),
                            // getDateField("tentativeStartDate", "Start date", setAsRequired(
                            //     setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                            //         "Please enter a valid date in 'dd-mm-yyyy' format",
                            //         this.common.AcceptDateAfter(0, 'Start date cannot be a past date', 'Start date',true, null)))),
                            // getSelectField("ptc.id", "PJC name", setAsRequired(this.common.getEmployeeSelectFieldOptions(this.ptcs$))),
                            // this.ptc(),                        
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            getDateField("tentativeStartDate", "Start date",
                                setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                                    "Please enter a valid date in 'dd-mm-yyyy' format",
                                    this.common.AcceptDateAfter(0, 'Start date cannot be a past date', 'Start date', true, null))),

                            this.pjcName(),
                            getSelectField("immigrationCaseType.id", "Immigration case type", this.common.getRequiredSelectFieldOptions(this.immigrationCaseType$, setAsRequired())),
                            //     getSelectField("immigrationCaseType.id", "Immigration case type",
                            //     //this.common.getSelectFieldOptions(this.immigrationCaseType$.pipe(map(item => item.filter(i => [1004, 1005].includes(i.id)))), '',
                            //      this.common.getSelectFieldOptionsWithDisable(this.immigrationCaseType$.pipe(map(item => item.filter(i => [1004, 1005,14420].includes(i.id)))), [1004],
                            //      setAsRequired())
                            //  ),
                        ]
                    },
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                
                             getSelectField(
                                    "embassy.id",
                                    "Embassy/Consulate (country)",setAsRequired(
                                    this.common.getSelectFieldOptions(this.nationality$, '',                         
                                    setRequiredWhen((model) => (!isNullOrUndefined(model.currentGccResident) && model.currentGccResident.id === 1074),this.addFieldTooltipWithAdditionalConfig('Embassy/Consulate (country)'))))),
                                              
                            this.cityOfEmbassy(),                           
                            getSelectField(
                                "ewakalaAgent.id",
                                "Should an Ewakala be issued to the mentioned agent?",
                                this.common.getSelectFieldOptions(this.yesNo$, '',
                                    this.common.getEwakalaIssuanceToAgentBasedOnImmCType(
                                        setAsRequired(this.addFieldTooltipWithAdditionalConfig('should an Ewakala be issued to the mentioned agent?'))
                                    ))),

                            this.RequestorName(),



                        ]
                    }
                ]
            }
        ];

    }


    GetAccepterSteps(): StepType[] {
        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            this.visaProcessorByOfficeLE(setAsRequired()),
                            //   this.Requestor()
                        ]
                    }
                ]
            }
        ];
    }



    GetApproverSteps(): StepType[] {

        return [
            {
                label: "Step 1",
                fields: [
                    {
                        fieldGroupClassName: "row",
                        fieldGroup: [
                            getInputField("passportNumber", "Passport number",this.addFieldTooltipWithAdditionalConfig('Passport number')),
                            this.visaProcessorByOfficeLE(
                                setAsRequired()
                            ),
                            // this.passportNumber(),
                            // this.passportExpiryDate(),
                            // this.passportExpiryDateOptional('Passport expiry date'),
                            // this.dateOfBirth(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                            // this.dateOfBirthOptional(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),
                            // this.placeOfBirth(),
                            // getInputField("placeOfBirth", "Place of birth (City,Country)"),
                            // getInputField(
                            //     "academicQualification",
                            //     "Academic qualification",
                            // setAsRequired()
                            // ),
                            this.immigrationStatus(),
                            //   this.Requestor(),

                            this.trackingNumber(setRequiredWhen((model) => !isNullOrUndefined(model.immigrationCaseType) && model.immigrationCaseType.id === 1005)),
                            getDateField("dateSoftcopyVisaDocumentsSent", "Date soft copy visa documents sent to requestor", setAsDisabled()),
                            getDateField("dateHardcopyVisaDocumentsSent", "Date hard copy visa documents given to AWS team", setAsDisabled()),
                            getDateField("dateCourierTrackingNumberSent", "Date courier tracking number sent to requestor", setAsDisabled()),
                            getDateField("dateHardCopyVisaDocumentsReceivedByVendorOrNJ",
                                "Date hard copy visa documents received by vendor or NJ",
                                setAsDisabled(
                                    setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                                        "Please enter a valid date in 'dd-mm-yyyy' format"))),

                            getDateField(
                                "courierDispatchDate",
                                "Courier dispatch date",
                                setRequiredWhen((model) => !isNullOrUndefined(model.immigrationCaseType) && model.immigrationCaseType.id === 1005,
                                    setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                                        "Please enter a valid date in 'dd-mm-yyyy' format")
                                )
                            ),
                            getInputField(
                                "agentCourierAddress",
                                "Agent Courier Address",
                                setAsReadOnlyRequiredWhen((model) => model.immigrationStatus.id === 5925, setAsHiddenWhen((model) => model.immigrationCaseType.id != 1005)))
                            ,
                            // getInputField("airwayBillNumber", "Airway bill number", setAsDisabled(this.AddTooltipToControl(FieldTooltip.AirwayBillNumber))),
                            // getDateField("dispatchDate", "Dispatch date", setAsDisabled(this.AddTooltipToControl(FieldTooltip.DispatchDate))),
                            // getInputField("courierCompanyName", "Courier company name",this.AddTooltipToControl(FieldTooltip.CourierCompanyName)),
                        ]
                    },

                ]
            }
        ];
    }
}
